import { Component, Input, ViewChild, inject } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AssetService } from '../../Model/AssetModule/asset.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../../Model/Common/common.service';

@Component({
  selector: 'app-asset-additional-detail',
  standalone: true,
  imports: [CommonModule,DataTablesModule,FormsModule],
  templateUrl: './asset-additional-detail.component.html',
  styleUrl: './asset-additional-detail.component.scss'
})
export class AssetAdditionalDetailComponent {
  isDisabled: boolean = false;
  TableDatas = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  ESS_AssetAdditionId=null as any;
  dtoptions: DataTables.Settings = {};
  constructor(
    private AssetService: AssetService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    protected common: CommonService,
  ) {
    this.route.params.subscribe(params => this.ESS_AssetAdditionId= parseInt(params['id']));
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.LoadAssetMaster();
   
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  
  LoadAssetMaster() {

    this.isDisabled = true;
    this.AssetService.LoadAssetAdditionDetail({ SelectType: 1, ESS_AssetAdditionId: this.ESS_AssetAdditionId }).subscribe({
      next: (response) => {
       this.TableDatas = Object.values(response);
       this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
       this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'AssetAdditionAttachment' + '/' + Text;
  }

}
